<template>
  <div class="no">
    404
    <el-button type="primary" @click="toHome" style="margin-top: 30px"
      >去首页
    </el-button>
  </div>
</template>

<script>
import { mapState } from "vuex";
import router from "@/router";
export default {
  name: "NoFound",
  components: {},
  methods: {
    toHome() {
      router.replace("/home").catch((err) => {
        console.log(err);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.no {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 60px;
  color: #999;
}
</style>
